<template>
    <div v-if="flashGreenMessage" class="alert alert-success" id="alert-green-msg">
            <button type="button" class="close" data-dismiss="alert">x</button>
            {{ flashGreenMessage }}
        </div>
        <div v-if="flashRedMessage" class="alert alert-danger" id="alert-red-msg">
            <button type="button" class="close" data-dismiss="alert">x</button>
            {{ flashRedMessage }}
        </div>
</template>

<script>
export default {
    data() {
        return {
            flashGreenMessage: document.getElementById('app').dataset.flashGreenMessage || '',
            flashRedMessage: document.getElementById('app').dataset.flashRedMessage || '',
        };
    },
};
</script>